module.exports = __webpack_public_path__ + "0c04969f369750e3c4ea9ceb4d9d20d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/xyz/lao/04.jpg
// module id = EgCr
// module chunks = 0